import React from 'react';

export const OverlayLoader = () => {
    return (
        <div data-testid="control-busy-overlay" className="control-busy-overlay"></div>
    )
}